<template>
  <div class="logout">
    <van-image src="/img/4.jpg" />
    <van-cell-group>
      <van-field v-model="username" clearable label="姓名" />
      <van-field v-model="workcode" clearable label="员工编码" />
      <van-field v-model="mobile" clearable label="手机号" />
      <div class="btn">
          <van-button type="info" style="font-size: 0.47333rem;background: #30cca8;border-radius: 50px;border: 0.02667rem solid #30cca8;font-weight:bold" @click="logout">退出登录</van-button>
      </div>
    </van-cell-group>
    <Bottom></Bottom>
  </div>
</template>

<script>
import { 
  Field,
  Grid,
  Cell,
  CellGroup,
  GridItem,
  Image,
  Icon,
  Button,
  TabbarItem
} from 'vant';
import Bottom from '../bottom/index.vue';
export default {
  components: {
    Bottom,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Image.name]: Image,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [TabbarItem.name]: TabbarItem,
    [Field.name]:Field,
    [Cell.name]:Cell,
    [CellGroup.name]:CellGroup
  },
  data() {
    return {
      username:localStorage.getItem("username"),
      workcode:localStorage.getItem("workcode"),
      mobile:localStorage.getItem("usermobile")
    };
  },
  methods: {
    logout() {
      this.$store.commit('changeActiveIndex', 0);
      localStorage.clear();
      this.$router.push('/login');
    }
      
  }
};
</script>

<style lang="less">
.logout {
    .van-image__img {
        height: 6rem;
    }
    .btn {
        text-align: center;
    }
    .van-button {
        width:94%;
    }
    
    
}
</style>
